import { render, staticRenderFns } from "./restrict-client.vue?vue&type=template&id=7fc29864&scoped=true"
import script from "./restrict-client.vue?vue&type=script&lang=js"
export * from "./restrict-client.vue?vue&type=script&lang=js"
import style0 from "./restrict-client.vue?vue&type=style&index=0&id=7fc29864&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fc29864",
  null
  
)

export default component.exports